import { AddressStatus, IAddress } from '@/models/address';

type AddressLike = Partial<IAddress> & { formatted?: string | null };

export const getActiveAddress = (
  source:
    | { addresses?: IAddress[] | null; address?: IAddress | null }
    | null
    | undefined,
): IAddress | null => {
  if (!source) return null;
  const list = source.addresses ?? [];
  if (list.length === 0) return source.address ?? null;
  return (
    list.find((a) => a?.status === AddressStatus.ACTIVE) ?? list[0] ?? null
  );
};

export const formatStreetLine = (
  address: AddressLike | null | undefined,
): string => {
  if (!address) return '';
  if (address.intersectionStreets?.length) {
    return address.intersectionStreets.filter(Boolean).join(' & ');
  }
  if (address.completeStreetName) {
    return [address.addressNumber, address.completeStreetName]
      .filter(Boolean)
      .join(' ');
  }
  return String(address.addressLabel || address.formatted || '');
};

export const formatCityStateZip = (
  address: AddressLike | null | undefined,
): string =>
  [address?.zipName, address?.state, address?.zipcode]
    .filter(Boolean)
    .join(', ');
